import axios from 'axios';
import config from '../config';

export interface VenueData {
  id: string;
  name: string;
  city?: string;
  state?: string;
  country: string;
  internal_id?: string;
  qr_code_svg_url?: string;
  qr_code_png_url?: string;
  onboard_url?: string;
  created_at?: string;
}

export interface LocationData {
  id: string;
  venue_id: string;
  label: string;
  qr_code_svg_url?: string;
  qr_code_png_url?: string;
  onboard_url?: string;
  created_at?: string;
}

export const getVenueById = async (venueId: string): Promise<VenueData> => {
  try {
    const response = await axios.get(`${config.API_BASE_URL}/api/venues/${venueId}/public`);
    return response.data;
  } catch (error) {
    console.error('Error fetching venue:', error);
    throw new Error('Failed to fetch venue information');
  }
};

export const getLocations = async (venueId: string): Promise<LocationData[]> => {
  try {
    const response = await axios.get(`${config.API_BASE_URL}/api/venues/${venueId}/locations`);
    return response.data.items || [];
  } catch (error) {
    console.error('Error fetching locations:', error);
    return [];
  }
};
